import { Component, ViewChild, AfterViewInit, OnInit, Inject, ElementRef } from '@angular/core';
import { HttpClient, HttpRequest, HttpEventType, HttpParams, HttpResponse } from '@angular/common/http';
import { CommissionService } from '../services/commission-service';
import { ContractService } from '../services/contract-service';
import { PopupContractComponent } from '../contract/contract-list.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ReportService } from '../services/report-service';
import { CommonService } from '../services/common-service';

//grid
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { jqxDropDownListComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxdropdownlist';
import { jqxInputComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxinput';
import { jqxWindowComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxwindow';
import { jqxLoaderComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxloader';
import { jqxRadioButtonComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxradiobutton';

@Component({
  templateUrl: '../main.component.html'
})

export class CommissionListComponent implements OnInit {
  public menuName = "Commission";
  public titleName = "Agent Commission";
  //public rowscount = 0;
  public edited = false;
  public isSearchDate = true;
  
  @ViewChild('cellBeginEditLog') cellBeginEditLog: ElementRef;
  @ViewChild('cellEndEditLog') cellEndEditLog: ElementRef;
  @ViewChild('myGrid') myGrid: jqxGridComponent;
  @ViewChild('myDropDownList') myDropDownList: jqxDropDownListComponent;
  @ViewChild('monthDropDownList') monthDropDownList: jqxDropDownListComponent;
  @ViewChild('yearDropDownList') yearDropDownList: jqxDropDownListComponent;
  @ViewChild('myInput') myInput: jqxInputComponent;
  @ViewChild('myWindow') myWindow: jqxWindowComponent;
  @ViewChild('MyLoader') MyLoader: jqxLoaderComponent;
  @ViewChild('startMonth') startMonth: jqxRadioButtonComponent;
  @ViewChild('betweenMonth') betweenMonth: jqxRadioButtonComponent;
  @ViewChild('endMonth') endMonth: jqxRadioButtonComponent;

  delrows: Array<any> = [];
  selectedcell: any;
  errorMessage: any;
  successMessage: any;
  contractContent: any;
  month: string = '';
  year: string = '';
  isShowAll: boolean = false;
  first_flg: boolean = true;
  loading_flg: boolean = true;
  month_flg_id: number = 0;// 0:start, 1:between, 2:end

  //get source
  constructor(private _commissionService: CommissionService, private _contractService: ContractService, private _reportService: ReportService,
              private _com: CommonService, private _router: Router, public dialog: MatDialog) {
  }

  ngOnInit() {
    this.month = this.getMonth();
    this.year = this.getYear();
    this.getCommissions();
  }

  getCommissions() {
    this.loading_flg = true;
    if (!(this.first_flg)) {
      this.MyLoader.open();
    }    
    this._commissionService.getCommissions(((this.isShowAll) ? '0' : this.month), ((this.isShowAll) ? '0' : this.year), this.month_flg_id)
      .subscribe((data) => {
        this.source.localdata = data;
        //this.rowscount = data.length;
        this.dataAdapter.dataBind();
        if (!(this.first_flg)) {
          this.MyLoader.close();
        }
        this.first_flg = false;
        this.loading_flg = false;
      });
  }

  getContract(id) {
    this._contractService.getContract(id).subscribe((data) => {
      this.contractContent = data;
    });
  }

  //datetime now
  getMonth() {
    return (new Date()).getMonth().toString();
  }
  getYear() {
    let year = (new Date()).getFullYear() - 2000;
    return year.toString();
  }

  //tool bar
  ngAfterViewInit(): void {
    this.createButtons();
    this.monthDropDownList.setOptions({ disabled: this.isShowAll });
    this.yearDropDownList.setOptions({ disabled: this.isShowAll });
    this.startMonth.setOptions({ disabled: this.isShowAll });
    this.betweenMonth.setOptions({ disabled: this.isShowAll });
    this.endMonth.setOptions({ disabled: this.isShowAll });
  }

  //Popup
  Rowdoubleclick(event: any): void {
    let selectedrowindex = this.myGrid.getselectedrowindex();
    let contractId = this.myGrid.getrowdata(selectedrowindex).contract_id;
    let deviceId = this.myGrid.getrowdata(selectedrowindex).device_id;
    let customerId = this.myGrid.getrowdata(selectedrowindex).customer_id;
    let agentPersonId = this.myGrid.getrowdata(selectedrowindex).agent_perosn_id;
    let dialogRef = this.dialog.open(PopupContractComponent, {
      width: '1000px',
      //height: 'auto*',
      disableClose: true,//20191007 close無し
      data: {
        contract_id: contractId,
        device_id: deviceId,
        customer_id: customerId,
        agent_perosn_id: agentPersonId,
        title: '(Edit/View)'
      }
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        //20191008 自分のタイミングで更新するように
        //this.getCommissions();
      });
  }

  //10/7/2019 Agent不要
  //dropDownSource: string[] = ['Agent', 'Agent Peson', 'Customer', 'Plan', 'Payment', 'Start', 'End', 'Item', 'Rate(%)', 'Commission', 'Month', 'Device'];
  dropDownSource: string[] = ['Agent', 'Customer', 'Plan', 'Payment', 'Start', 'End', 'Item', 'Rate(%)', 'Commission', 'Month', 'Device'];

  groups: any[] = ['agent_person_name'];
  getPagesize(): any {
    return 100;
  }
  //grid 
  source: any =
    {
      datatype: 'json',
      datafields: [
        { name: 'row_index', type: 'int' },
        { name: 'contract_id', type: 'int' },
        //{ name: 'agent_id', type: 'int' },
        //{ name: 'agent_name', type: 'string' },
        { name: 'agent_person_id', type: 'int' },
        { name: 'agent_person_name', type: 'string' },
        { name: 'customer_id', type: 'int' },
        { name: 'customer_name', type: 'string' },
        { name: 'payment_id', type: 'int' },
        { name: 'payment_name', type: 'string' },
        { name: 'plan_id', type: 'int' },
        { name: 'term_name', type: 'string' },
        { name: 'start_date', type: 'date' },
        { name: 'end_date', type: 'date' },
        { name: 'item_name', type: 'string' },
        { name: 'rate', type: 'float', cellsformat: 'c2' },
        { name: 'commission', type: 'float', cellsformat: 'c2' },
        { name: 'paid_start_date', type: 'date' },
        { name: 'device_id', type: 'int' }
      ],
      id: 'row_index',
      localdata: {},
      sortcolumn: 'agent_person_name'
    };
  dataAdapter: any = new jqx.dataAdapter(this.source);

  getWidth(): any {
    return '100%';
  }
  getTotal(): any {
    return true;
  }

  contractsSource: any =
    {
      //datatype: 'array',
      datatype: 'array',
      datafields: [
        { name: 'contract_id', type: 'int' },
        { name: 'contract_no', type: 'string' }
      ],
      localdata: {}
    };
  contractsAdapter: any = new jqx.dataAdapter(this.contractsSource, { autoBind: true });
  //columns
  columns: any[] =
    [
      //{ text: 'Agent ID', datafield: 'agent_id', width: '15%', columntype: 'textbox', hidden:true },
      //{ text: 'Agent', datafield: 'agent_name', width: '15%', columntype: 'textbox', editable: false },
      { text: 'Agent ID', datafield: 'agent_person_id', width: '20%', columntype: 'textbox', hidden: true },
      { text: 'Agent', datafield: 'agent_person_name', width: '20%', columntype: 'textbox', editable: false },
      { text: 'Customer ID', datafield: 'customer_id', width: '20%', columntype: 'textbox', hidden: true  },
      { text: 'Customer', datafield: 'customer_name', width: '20%', columntype: 'textbox', editable: false },
      { text: 'Plan', datafield: 'term_name', width: '5%', columntype: 'textbox', editable: false },
      { text: 'Payment', datafield: 'payment_name', width: '5%', columntype: 'textbox', editable: false },
      { text: 'Start', datafield: 'start_date', width: '10%', columntype: 'datetimeinput', cellsformat: 'MM/dd/yyyy', editable: false },
      { text: 'End', datafield: 'end_date', width: '10%', columntype: 'datetimeinput', cellsformat: 'MM/dd/yyyy', editable: false },
      { text: 'Item', datafield: 'item_name', width: '7%', columntype: 'textbox', editable: false },
      {
        text: 'Rate(%)', datafield: 'rate', width: '5%', cellsalign: 'right', cellsformat: 'd', columntype: 'numberinput', editable: false, 
        initeditor: function (row, cellvalue, editor) {
          editor.jqxNumberInput({ digits: 5 });
        },
      },
      {
        text: 'Commission($)', datafield: 'commission', aggregates: ["sum"], width: '11%', cellsalign: 'right', cellsformat: 'c2', columntype: 'numberinput', editable: false,
        initeditor: function (row, cellvalue, editor) {
          editor.jqxNumberInput({ digits: 5 });
        },
        cellsrenderer: function (row, column, value, defaultRender, rowData) {
          if (value.toString().indexOf("Sum") >= 0) {
            return defaultRender.replace("Sum:", "Sub Total : ");
          }
        },
        aggregatesrenderer: function (aggregates, column, element) {
          var renderstring = '<div style="position: relative; margin-top: 4px; margin-right:5px; text-align: right; overflow: hidden;">' + "Grand Total" + ' : ' + aggregates.sum + '</div>';
          return renderstring;
        }
      },
      { text: 'Paid Start', datafield: 'paid_start_date', width: '7%', columntype: 'datetimeinput', cellsformat: 'MMM dd', editable: false },
      { text: 'Device ID', datafield: 'device_id', width: '5%', columntype: 'textbox', hidden: true },
    ];

  groupsrenderer(text, group, expanded, data): any {
   var color;
    switch (data.level) {
      case 0:
        color = '#B0BEC5';
        break;
      case 1:
        color = '#CFD8DC';
        break;
      case 2:
        color = '#ECEFF1';
        break;
      case 3:
        color = '#EEEEEE';
        break;
      case 4:
        color = '#F5F5F5';
        break;
      case 5:
        color = '#FAFAFA';
        break;
    } 
    return '<div style="width: 100%; height: 100%; background-color: #CFD8DC; color:Black; line-height:30px;"><span style="font-weight:bold; vertical-align: middle;">' + text + '</span></div>';
  }

  //add row
  generatedata(): any {
    let row = {}; 
    row['row_index'] = 0;
    row['contract_id'] = 0;
    //row['agent_id'] = 0;
    //row['agent_name'] = "";
    row['agent_full_address'] = "";
    row['agent_person_id'] = 0;
    row['agent_person_name'] = "";
    row['customer_id'] = 0;
    row['customer_name'] = "";
    row['plan_id'] = 0;
    row['term_name'] = "";
    row['item_id'] = 0;
    row['item_name'] = "";
    row['payment_id'] = 0;
    row['payment_name'] = "";
    row['contract_period_id'] = 0;
    row['start_date'] = "";
    row['end_date'] = "";
    row['contract_type_id'] = 0;
    row['contract_type'] = "";
    row['rate'] = 0;
    row['commission'] = 0;
    row['device_id'] = 0;
    row['paid_start_date'] = "";
    return row;
  }


  //Dropdown month
  dropDownMonth: number[] = this._com.getMonthDropDownList();

  //Dropdown year
  dropDownYear: number[] = this._com.getYearDropDownList();

  //Filtering
  monthOnSelect(event: any): void {
    let args = event.args;
    let item = this.monthDropDownList.getItem(args.index);
    if (item != null) {
      this.month = this.monthDropDownList.getSelectedIndex().toString();
      this.getCommissions();
    }
  };
  yearOnSelect(event: any): void {
    let args = event.args;
    let item = this.yearDropDownList.getItem(args.index);
    if (item != null) {
      this.year = this.yearDropDownList.getSelectedIndex().toString();
      this.getCommissions();
    }
  };

  periodCheckBoxOnChange(event: any): void {
    let args = event.args;
    this.isShowAll = args.checked;
    if (args.checked == true) {
      this.month = '0';
      this.year = '0';
      this.betweenMonth.setOptions({ checked: !(this.isShowAll) });
      this.endMonth.setOptions({ checked: !(this.isShowAll) });
      this.startMonth.setOptions({ checked: this.isShowAll });
      this.month_flg_id = 0;
    }
    else {
      this.month = this.monthDropDownList.getSelectedIndex().toString();
      this.year = this.yearDropDownList.getSelectedIndex().toString();
    }
    this.monthDropDownList.setOptions({ disabled: this.isShowAll });
    this.yearDropDownList.setOptions({ disabled: this.isShowAll });
    this.getCommissions();
    this.startMonth.setOptions({ disabled: this.isShowAll });
    this.betweenMonth.setOptions({ disabled: this.isShowAll });
    this.endMonth.setOptions({ disabled: this.isShowAll });
  };

  //Target Month status
  startBtnOnClick(event: any): void {
    this.monthBtnSetValue(0);
  }
  betweenBtnOnClick(event: any): void {
    this.monthBtnSetValue(1);
  }
  endBtnOnClick(event: any): void {
    this.monthBtnSetValue(2);
  }

  monthBtnSetValue(code) {
    if (!(this.isShowAll)) {
      this.month_flg_id = code;
      this.getCommissions();
    }
  }

  //tool buttons
  createButtonsContainers(statusbar: any): void {
    let buttonsContainer = document.createElement('div');
    buttonsContainer.style.cssText = 'overflow: hidden; position: relative; margin: 5px;';
    //let addButtonContainer = document.createElement('div');
    //let deleteButtonContainer = document.createElement('div');
    let reloadButtonContainer = document.createElement('div');
    //let searchButtonContainer = document.createElement('div');
    //let saveButtonContainer = document.createElement('div');
    //addButtonContainer.id = 'addButton';
    //deleteButtonContainer.id = 'deleteButton';
    reloadButtonContainer.id = 'reloadButton';
    //searchButtonContainer.id = 'searchButton';
    //saveButtonContainer.id = 'saveButton';
    //addButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    //deleteButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    reloadButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    //searchButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    //saveButtonContainer.style.cssText = 'float: right; margin-right: 5px;';
    //addButtonContainer.className = 'btn btn-default';
    //deleteButtonContainer.className = 'btn btn-default';
    reloadButtonContainer.className = 'btn btn-default';
    //searchButtonContainer.className = 'btn btn-default';
    //saveButtonContainer.className = 'btn btn-default';
    //buttonsContainer.appendChild(addButtonContainer);
    //buttonsContainer.appendChild(deleteButtonContainer);
    buttonsContainer.appendChild(reloadButtonContainer);
    //buttonsContainer.appendChild(searchButtonContainer);
    //buttonsContainer.appendChild(saveButtonContainer);
    statusbar[0].appendChild(buttonsContainer);
  }

  //create tool buttons
  createButtons(): void {
    //let addButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-plus' style='color:darkseagreen;'></span> Add"
    //}
    //let addButton = jqwidgets.createInstance('#addButton', 'jqxButton', addButtonOptions);
    //let deleteButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-remove' style='color:indianred;'></span> Delete"
    //}
    //let deleteButton = jqwidgets.createInstance('#deleteButton', 'jqxButton', deleteButtonOptions);
    let reloadButtonOptions = {
      width: 40, height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-refresh' style='color:darkblue;' title='Reload'></span>"
    }
    let reloadButton = jqwidgets.createInstance('#reloadButton', 'jqxButton', reloadButtonOptions);
    //let searchButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-search' style='color:slategrey;' title='Find'></span>"
    //}
    //let searchButton = jqwidgets.createInstance('#searchButton', 'jqxButton', searchButtonOptions);
    //let saveButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-floppy-disk' style='color:#2E7D32;'></span> Save"
    //}
    //let saveButton = jqwidgets.createInstance('#saveButton', 'jqxButton', saveButtonOptions);

    //// add new row.
    //addButton.addEventHandler('click', (event: any): void => {
    //  let datarow = this.generatedata();
    //  this.myGrid.addrow(null, datarow);
    //});
    //// delete selected row.
    //deleteButton.addEventHandler('click', (event: any): void => {
    //  let selectedrowindex = this.myGrid.getselectedrowindex();
    //  let rowscount = this.myGrid.getdatainformation().rowscount;
    //  let id = this.myGrid.getrowid(selectedrowindex);
    //  this.myGrid.deleterow(id);
    //  this.delrows.push(id);
    //});
    // reload grid data.
    reloadButton.addEventHandler('click', (event: any): void => {
      this.getCommissions();
      this.delrows = [];
      this.selectedcell = null;
    });
    // search for a record.
    //searchButton.addEventHandler('click', (event: any): void => {
    //  this.myWindow.open();
    //  this.myWindow.move(60, 60);
    //});
    //// save records.
    //saveButton.addEventHandler('click', (event: any): void => {
    //  //confirm changes
    //  let selectedrowindex = this.myGrid.getselectedrowindex();
    //  console.log("this.selectedcell :" + this.selectedcell);
    //  this.myGrid.endcelledit(selectedrowindex, this.selectedcell, false);

    //  let rows = this.myGrid.getrows();
    //  rows.forEach(commission => {
    //    if (commission.commission_id == 0) {
    //      console.log("commission :" + commission);
    //      this._commissionService.addCommission(commission)
    //        .subscribe((data) => {
    //          this.getCommissions();
    //        }, error => this.errorMessage = error._body)
    //    }
    //    else {
    //      this._commissionService.updateCommission(commission)
    //        .subscribe((data) => {
    //          this.getCommissions();
    //        }, error => this.errorMessage = error._body)
    //    }
    //  });
    //  this.delrows.forEach(commissionId => {
    //    if (commissionId != "0") {
    //      this._commissionService.deleteCommission(commissionId).subscribe((data) => {
    //        this.getCommissions();
    //      }, error => console.error(error))
    //    }
    //  });
    //  this.delrows = [];
    //  this.selectedcell = null;

    //});
  }

  //find button
  findBtnOnClick(): void {
    this.myGrid.clearfilters();
    let searchColumnIndex = this.myDropDownList.selectedIndex();
    let datafield = '';
    switch (searchColumnIndex) {
      //case 0:
      //  datafield = 'agent_name';
      //  break;
      case 0:
        datafield = 'agent_person_name';
        break;
      case 1:
        datafield = 'customer_name';
        break;
      case 2:
        datafield = 'term_name';
        break;
      case 3:
        datafield = 'item_name';
        break;
      case 4:
        datafield = 'payment_name';
        break;
      case 5:
        datafield = 'start_date';
        break;
      case 6:
        datafield = 'end_date';
        break;
      case 7:
        datafield = 'rate';
        break;
      case 8:
        datafield = 'commission';
        break;
      case 9:
        datafield = 'paid_start_date';
        break;
      case 10:
        datafield = 'device_id';
        break;
    }
    let searchText = this.myInput.val();
    let filtergroup = new jqx.filter();
    let filter_or_operator = 1;
    let filtervalue = searchText;
    let filtercondition = 'contains';
    let filter = filtergroup.createfilter('stringfilter', filtervalue, filtercondition);
    filtergroup.addfilter(filter_or_operator, filter);
    this.myGrid.addfilter(datafield, filtergroup);
    // apply the filters.
    this.myGrid.applyfilters();
  }

  //clear btn
  clearBtnOnClick(): void {
    this.myGrid.clearfilters();
  }

  //edit function
  rowValues: string = '';
  myGridOnCellBeginEdit(event: any): void {
    let args = event.args;
    this.selectedcell = args.datafield;
  };
  myGridOnCellEndEdit(event: any): void {
  };

  //print pdf
  printBtnOnClick() {
    this._reportService.showPrint(this.myGrid, 'Agent Commission');

  };

  //export excel
  excelBtnOnClick() {
    this._reportService.exportExcel(this.myGrid, 'Agent Commission');
  };

  onPageChanged(): void {
    this.myGrid.expandallgroups();
  }

  //Close Message
  closeSuccessMessage() {
    this.successMessage = null;
  }
  closeErrorMessage() {
    this.errorMessage = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/commission/commission-list.component.ts